import React from "react";
import { injectIntl } from "gatsby-plugin-react-intl";
import Seo from "../components/Seo/Seo";

const Redirect = ({ intl }) => {
  return <Seo title={`${intl.formatMessage({ id: "title" })}`} />;
};

export default injectIntl(Redirect);
